import React, { useState, useEffect } from 'react';

// custom components 
import { AssistanceSelector, AirportSelector, WheelchairInformation } from "_molecules";

// bootstrap
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

// styles 
import { Colors } from '_styles';
import { AiOutlineCloseCircle } from "react-icons/ai";

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectBookingForm, setBookingForm } from '_redux/slices/assistance-bookings/booking-form';
import { postError } from '_redux/slices/prm-bookings/bookings';
import { normalizeErrors } from '_utils/functions';
import { selectIata, selectUserDb } from '_redux/slices/main-screen/user';



const PassengerInformationForm = (props) => {

    //#region state variables 
    const [equipmentQuestion, setEquipmentQuestion] = useState(false);      // show equipment question if passengers selected a wheelchair type assistance
    const [title, setTitle] = useState('');                                 // set passenger title in form
    // errors
    const [errors, setErrors] = useState({});

    // redux
    const dispatch = useDispatch();
    const bookingForm = useSelector(selectBookingForm);                     // hold booking form info
    const errorList = useSelector(postError);                                // holds list of errors from posting booking
    const iata = useSelector(selectIata);
    const userDb = useSelector(selectUserDb);

    //#endregion

    //#region form handlers 
    const setFirstName = (value) => {
        let tempList = [...bookingForm]; // copy list
        const newObj = Object.assign({}, tempList[props.index], { firstName: value });        // create a new object with a writable firstName property
        tempList[props.index] = newObj; // update list with new object
        dispatch(setBookingForm(tempList));
    }
    const setSecondName = (value) => {
        let tempList = [...bookingForm]; // copy list
        const newObj = Object.assign({}, tempList[props.index], { secondName: value });        // create a new object with a writable firstName property
        tempList[props.index] = newObj; // update list with new object
        dispatch(setBookingForm(tempList));
    }
    const setAssistance = (value) => {
        let tempList = [...bookingForm]; // copy list
        const newObj = Object.assign({}, tempList[props.index], { assistance: value });        // create a new object with a writable firstName property
        tempList[props.index] = newObj; // update list with new object
        dispatch(setBookingForm(tempList));
    }
    const setBio = (value) => {
        let tempList = [...bookingForm]; // copy list
        const newObj = Object.assign({}, tempList[props.index], { prmBio: value });        // create a new object with a writable firstName property
        tempList[props.index] = newObj; // update list with new object
        dispatch(setBookingForm(tempList));
    }
    const setAirlineConfirmed = (value) => {
        let tempList = [...bookingForm]; // copy list
        const newObj = Object.assign({}, tempList[props.index], { airlineConfirmed: value });        // create a new object with a writable firstName property
        tempList[props.index] = newObj; // update list with new object
        dispatch(setBookingForm(tempList));
    }

    const setAmbiliftRequired = (value) => {
        let tempList = [...bookingForm]; // copy list
        const newObj = Object.assign({}, tempList[props.index], { ambiliftRequired: value });        // create a new object with a writable firstName property
        tempList[props.index] = newObj; // update list with new object
        dispatch(setBookingForm(tempList));
    }
    const showEquipment = (value) => {
        let tempList = [...bookingForm]; // copy list
        const newObj = Object.assign({}, tempList[props.index], { equipment: value });        // create a new object with a writable firstName property
        tempList[props.index] = newObj; // update list with new object
        dispatch(setBookingForm(tempList));
    }
    const handleReferenceNumber = (value) => {
        let tempList = [...bookingForm]; // copy list
        const newObj = Object.assign({}, tempList[props.index], { referenceNumber: value });        // create a new object with a writable firstName property
        tempList[props.index] = newObj; // update list with new object
        dispatch(setBookingForm(tempList));
    }
    // set title 
    useEffect(() => {
        if (title.length > 0) {
            let tempList = [...bookingForm]; // copy list
            const newObj = Object.assign({}, tempList[props.index], { title: title + ' ' });        // create a new object with a writable firstName property
            tempList[props.index] = newObj; // update list with new object
            dispatch(setBookingForm(tempList));
        }
    }, [title]);
    // show equpment question handler
    useEffect(() => {
        if (bookingForm[props.index].assistance.includes('WCHS') || bookingForm[props.index].assistance.includes('WCHR') || bookingForm[props.index].assistance.includes('WCMP') || bookingForm[props.index].assistance.includes('WCHC')) {
            setEquipmentQuestion(true)
        }
        else {
            setEquipmentQuestion(false)
        }
    }, [bookingForm[props.index]]);
    //#endregion

    // handle error display
    useEffect(() => {
        const incoming = bookingForm?.[props.index]?.errors; // could be {}, [] or undefined
        const incomingObj = normalizeErrors(incoming);

        // if Redux has nothing meaningful, don't touch local errors
        if (!incomingObj || Object.keys(incomingObj).length === 0) return;

        setErrors(prev => {
            const next = { ...prev };
            // Only apply non-empty messages; keep previous if incoming is empty/undefined
            Object.entries(incomingObj).forEach(([field, msg]) => {
                if (msg) next[field] = msg;  // merge without wiping existing
            });
            return next;
        });
    }, [bookingForm, props.index]);

    // delete passenger from passenger list
    const deletePassenger = () => {
        let tempList = [...bookingForm];
        tempList.splice(props.index, 1)
        dispatch(setBookingForm(tempList))
    }

    const handleChange = (value, target) => {
        const nameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ' -]+$/;

        //Update the field (so clearing works)
        if (target === "firstName") setFirstName(value);
        if (target === "secondName") setSecondName(value);

        // 2) Validate and set field-specific error
        let msg = "";
        if (value.trim() === "") {
            msg = "This field is required";
        } else if (!nameRegex.test(value)) {
            msg = "Name must only contain letters, spaces, hyphens, and apostrophes";
        }

        setErrors((prev) => ({ ...prev, [target]: msg }));
    };

    const hasError = (field) => errors[field] && errors[field].length > 0;

    return (
        <div style={passengerStyles.card}>
            <Form>
                {/* Passenger Header */}
                <div style={passengerStyles.header}>
                    <div style={passengerStyles.headerLeft}>
                        <div style={passengerStyles.avatar}>
                            {props.index + 1}
                        </div>
                        <span style={passengerStyles.headerTitle}>
                            Passenger {props.index + 1}
                        </span>
                    </div>
                    {props.index !== 0 && (
                        <button onClick={deletePassenger} style={passengerStyles.removeBtn}>
                            <AiOutlineCloseCircle size={16} color={Colors.DARK_RED} />
                            <span>Remove</span>
                        </button>
                    )}
                </div>

                {/* Name Fields */}
                <Form.Group style={{ marginTop: 16 }}>
                    <Row>
                        <Col>
                            <Row>
                                {props.title && (
                                    <Col xs={3}>
                                        <Form.Label style={passengerStyles.label}>Title <span style={passengerStyles.optional}>(Optional)</span></Form.Label>
                                        <Form.Select onChange={(value) => { setTitle(value.target.value) }} style={passengerStyles.input}>
                                            <option> </option>
                                            <option>Mr.</option>
                                            <option>Ms.</option>
                                            <option>Mrs.</option>
                                            <option>Miss</option>
                                            <option>Dr.</option>
                                        </Form.Select>
                                    </Col>
                                )}
                                <Col>
                                    <Form.Label style={{ ...passengerStyles.label, color: hasError('firstName') ? Colors.DARK_RED : Colors.TEXT_COLOR }}>First Name</Form.Label>
                                    <Form.Control
                                        onChange={(e) => { handleChange(e.target.value, "firstName") }}
                                        type="text"
                                        placeholder="e.g. John"
                                        style={{ ...passengerStyles.input, borderColor: hasError('firstName') ? Colors.DARK_RED : '#dee2e6' }}
                                        value={bookingForm[props.index].firstName}
                                    />
                                    {hasError('firstName') && (
                                        <p style={passengerStyles.errorMsg}>{errors.firstName}</p>
                                    )}
                                </Col>
                                <Col>
                                    <Form.Label style={{ ...passengerStyles.label, color: hasError('secondName') ? Colors.DARK_RED : Colors.TEXT_COLOR }}>Last Name</Form.Label>
                                    <Form.Control
                                        onChange={(e) => { handleChange(e.target.value, "secondName") }}
                                        type="text"
                                        placeholder="e.g. Smith"
                                        style={{ ...passengerStyles.input, borderColor: hasError('secondName') ? Colors.DARK_RED : '#dee2e6' }}
                                        value={bookingForm[props.index].secondName}
                                    />
                                    {hasError('secondName') && (
                                        <p style={passengerStyles.errorMsg}>{errors.secondName}</p>
                                    )}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form.Group>

                {/* Assistance Requirements */}
                <Form.Group style={{ marginTop: 16 }}>
                    <Form.Label style={{ ...passengerStyles.label, color: hasError('assistance') ? Colors.DARK_RED : Colors.TEXT_COLOR }}>Assistance Requirements</Form.Label>
                    <AssistanceSelector setAssistance={(e) => { setAssistance(e) }} value={bookingForm[props.index].assistance} isBooking={true} />
                    {hasError('assistance') && (
                        <p style={passengerStyles.errorMsg}>{errors.assistance}</p>
                    )}
                </Form.Group>

                {/* Airline Confirmation & Airport Selection */}
                <Form.Group style={{ marginTop: 16 }}>
                    <Row>
                        {userDb?.details.type !== "AIRLINE" && <Col>
                            <Form.Label style={passengerStyles.label}>Confirmed with airline?</Form.Label>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
                                <Form.Check
                                    onClick={(e) => { setAirlineConfirmed(e.target.checked) }}
                                    type="switch"
                                    defaultChecked={bookingForm[props.index].airlineConfirmed}
                                />
                                <span style={{ fontSize: 13, color: bookingForm[props.index].airlineConfirmed ? Colors.DARK_GREEN : Colors.GRAY_DARK, fontWeight: 500 }}>
                                    {bookingForm[props.index].airlineConfirmed ? 'Yes' : 'No'}
                                </span>
                            </div>
                        </Col>}
                        <Col>
                            <Form.Label style={{ ...passengerStyles.label, color: hasError('assistanceSelector') ? Colors.DARK_RED : Colors.TEXT_COLOR }}>Airports requiring assistance</Form.Label>
                            <AirportSelector bookingForm={bookingForm} errors={errors} index={props.index} />
                        </Col>
                    </Row>
                    {iata === "PUJ" && <Row>
                        <Col>
                            <Form.Label style={passengerStyles.label}>Ambilift Required?</Form.Label>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
                                <Form.Check
                                    onClick={(e) => { setAmbiliftRequired(e.target.checked) }}
                                    type="switch"
                                    defaultChecked={bookingForm[props.index].ambiliftRequired}
                                />
                                <span style={{ fontSize: 13, color: bookingForm[props.index].ambiliftRequired ? Colors.DARK_GREEN : Colors.GRAY_DARK, fontWeight: 500 }}>
                                    {bookingForm[props.index].ambiliftRequired ? 'Yes' : 'No'}
                                </span>
                            </div>
                        </Col>

                    </Row>}
                </Form.Group>

                {/* Equipment Toggle */}
                {equipmentQuestion && (
                    <Form.Group style={{ marginTop: 16 }}>
                        <Form.Label style={passengerStyles.label}>Personal Equipment</Form.Label>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
                            <Form.Check onClick={(e) => { showEquipment(e.target.checked) }} type="switch" defaultChecked={bookingForm.equipment} />
                            <span style={{ fontSize: 13, color: Colors.TEXT_COLOR }}>Passenger will bring own equipment</span>
                        </div>
                    </Form.Group>
                )}

                {/* Wheelchair Information */}
                <WheelchairInformation show={bookingForm[props.index].equipment} index={props.index} />
            </Form>
        </div>
    );
};

const passengerStyles = {
    card: {
        background: '#FAFBFC',
        border: '1px solid #E8ECF0',
        borderRadius: 10,
        padding: '20px 24px',
        marginBottom: 12,
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    headerLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
    },
    avatar: {
        width: 30,
        height: 30,
        borderRadius: '50%',
        backgroundColor: Colors.PRM_LIGHT_BLUE,
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 13,
        fontWeight: 600,
    },
    headerTitle: {
        fontSize: 14,
        fontWeight: 600,
        color: Colors.TEXT_COLOR,
    },
    removeBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        padding: '4px 10px',
        border: 'none',
        background: Colors.LIGHT_RED,
        borderRadius: 6,
        cursor: 'pointer',
        fontSize: 12,
        fontWeight: 500,
        color: Colors.DARK_RED,
    },
    label: {
        fontSize: 13,
        fontWeight: 500,
        color: Colors.TEXT_COLOR,
        marginBottom: 4,
    },
    optional: {
        fontWeight: 400,
        color: Colors.GRAY_DARK,
    },
    input: {
        borderRadius: 8,
        fontSize: 14,
    },
    errorMsg: {
        color: Colors.DARK_RED,
        fontSize: 12,
        marginTop: 4,
        marginBottom: 0,
    },
};

export default PassengerInformationForm;
